import axiosInstance from "../helpers/AxiosHelper";

const STORE_ENDPOINT = "/store";
type AddStoreRequest = {
  storeNumber: string;
  userId: string;
  userType: string;
};

export async function getStores(): Promise<any[]> {
  try {
    const response = await axiosInstance.get('/napaStores');
    return response.data;
  } catch (e) {
    return Promise.reject(e);
  }
}

export async function addStore(request: AddStoreRequest): Promise<any[]> {
  try {
    const response = await axiosInstance.post(`${STORE_ENDPOINT}`, request);
    return response.data;
  } catch (e) {
    return Promise.reject(e);
  }
}

export type StoreDetails = {
  storeNumber: string
  addressLine1: string
  addressLine2: string
  city: string
  state: string
  zipCode: string
  latitude: number
  longitude: number
  doordashEnabledFlag: boolean
  autoDispatch: boolean
  companyOwnedFlag: boolean
}

export async function getStoreDetails(storeNumber: string): Promise<StoreDetails> {
  try {
    const response = await axiosInstance.get<StoreDetails>(`/napaStores/store/${storeNumber}`)
    if (response.status === 200) {
      return response.data
    }
    return Promise.reject(`[${response.status}]: ${response.data}`)
  } catch (e) {
    return Promise.reject(e);
  }
}
